var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedMenu == 1)?_c('div',{staticClass:"uv-card"},[_c('div',{staticClass:"uv-card-body"},[_c('ModuleHeader',[_vm._v("Miembros")]),_c('uv-data-table',{attrs:{"config":_vm.config,"data":_vm.comp_clients,"pageRows":15},on:{"buttonClick":_vm.dtButtonClick}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }